// Adresse déclarée d'un site = hôte pur `url` + `base_path` (contrat C9, google-sites-install:B2_05).
//
// ⚠ COPIE DÉLIBÉRÉE de `api/src/services/websiteBaseUrl.js` (`normalizeBasePath` + `baseUrlOf`) :
// le super-admin ne peut pas importer l'api (même choix que `src/lib/moderationAgents.js`). Une
// règle changée côté api doit l'être ICI aussi — aucun test ne rattrape la dérive entre les deux.
//
// Chemin ABSENT = racine (D93, google-sites-install:B5_04) : c'est l'état normal de presque tout le
// parc (un agrégat ou un `lean` ne pose pas le défaut Mongoose `'/'`). Seule exception, choisie par
// l'appelant (`absentKey: 'unknown'`) : l'écran du suivi du parc, dont l'API sert TOUJOURS la clé
// (défaut `'/'` côté API, contrat C7 amendé) — une clé absente y signe une API pas encore déployée
// (super-admin sur `master`, API sur `dev`), état `known:false` : on rend l'hôte, jamais un chemin
// inventé (piège CLAUDE.md « champ d'API pas encore déployé »).
// Fonctions pures, testées dans `src/tests/websiteAddress.test.js`.

const GOOGLE_SITES_HOST_RE = /^https?:\/\/sites\.google\.com$/i;

// `''`, `null`, `'/'` → `'/'` ; sinon `/` initial garanti, `/` final unique, jamais de `//`.
export function normalizeBasePath(input) {
  const raw = (input ?? '').toString().trim();
  if (!raw || raw === '/') return '/';
  const collapsed = `/${raw}`.replace(/\/{2,}/g, '/').replace(/\/+$/, '');
  return `${collapsed}/`;
}

// → { address, distinct, known } : `address` sans `/` final (comme `baseUrlOf`), `distinct` = le
// site a un chemin (l'adresse diffère de l'hôte), `known` = faux seulement en mode `unknown`
// quand la clé `base_path` manque à la réponse.
export function websiteAddress(site, { absentKey = 'root' } = {}) {
  const host = ((site && site.url) || '').toString().trim().replace(/\/+$/, '');
  const hasKey = Boolean(site) && site.base_path !== undefined;
  if (!hasKey && absentKey === 'unknown') {
    return { address: host, distinct: false, known: false };
  }
  const basePath = normalizeBasePath(hasKey ? site.base_path : undefined);
  const distinct = basePath !== '/';
  if (!host) return { address: '', distinct, known: true };
  return {
    address: distinct ? `${host}${basePath}`.replace(/\/+$/, '') : host,
    distinct,
    known: true
  };
}

// D103 : un Google Sites sans domaine propre ET sans chemin connu n'a pas d'adresse utile —
// `https://sites.google.com` ouvre l'accueil de Google Sites, pas le site du client. Un Google
// Sites sur domaine personnalisé à la racine a, lui, une adresse valide (hôte ≠ sites.google.com).
// Seulement pour une adresse CONNUE : `known:false` (API ancienne) rend l'hôte tel quel.
export function isUndeclaredGoogleSitesAddress(result) {
  return Boolean(result && result.known && !result.distinct && GOOGLE_SITES_HOST_RE.test(result.address));
}
